import sumBy from 'lodash/sumBy'

const A_PENNY = 0.01

// Bankers Rounding is an algorithm in which numbers which are
// equidistant from the two nearest integers are rounded to
// the nearest even integer. Thus, 0.5 rounds down to 0; 1.5 rounds up to 2.
// http://stackoverflow.com/a/3109234
export function bankersRounding(num, decimalPlaces = 2) {
  const decimalMultiplier = Math.pow(10, decimalPlaces)
  const numMultiplied = (decimalPlaces ? num * decimalMultiplier : num).toFixed(
    8
  ) // Avoid rounding errors
  const numMultipliedWithoutDecimals = Math.floor(numMultiplied) // drop the decimal places
  const leftOverDecimals = numMultiplied - numMultipliedWithoutDecimals
  const e = 1e-8 // Allow for rounding errors in leftOverDecimals
  const roundedNum =
    leftOverDecimals > 0.5 - e && leftOverDecimals < 0.5 + e
      ? numMultipliedWithoutDecimals % 2 == 0
        ? numMultipliedWithoutDecimals
        : numMultipliedWithoutDecimals + 1
      : Math.round(numMultiplied)
  return roundedNum / decimalMultiplier
}

export function roundToCentsEqualingTotal(totalAmount, lineItems, valueName) {
  // check if the sum of the prorated amounts matches the total amount
  const roundedTotal = sumBy(lineItems, valueName)
  const leftOverCents = bankersRounding((totalAmount - roundedTotal) * 100)

  // loop through line items to apply left over cents
  return lineItems.map((li, index) => {
    if (index >= Math.abs(leftOverCents)) {
      return li
    }
    const adjustedAmount =
      leftOverCents > 0 ? li[valueName] + A_PENNY : li[valueName] - A_PENNY

    return {
      ...li,
      [valueName]: bankersRounding(adjustedAmount)
    }
  })
}

export function getLicensingMarkup(percentage) {
  // The current prep API does a markup calculation that makes no sense,
  // but is replicated here for consistency.
  const ratio = percentage / 100
  const markup = 1 + ratio / (1 - ratio)

  return markup
}

export function applyLicensingFee(price, percentage = 0) {
  const markup = getLicensingMarkup(percentage)

  price *= markup
  // Always round up to 99 cents
  const ceilPrice = Math.ceil(price)
  price = ceilPrice === price ? ceilPrice : ceilPrice - 0.01

  return price
}
export function applySizeSurcharge(price, surcharge = 0) {
  return (price += surcharge)
}
